<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppFlicker } from '@libs/ui';

const browserStore = useBrowserStore();
</script>

<template>
  <div class="activity-details-main-loader">
    <AppFlicker
      width="100%"
      :height="
        browserStore.isSmallerThan900px ? 'font-size-h5' : 'font-size-h3'
      "
      border-radius="border-radius-12"
    />
    <AppFlicker
      width="50%"
      :height="browserStore.isSmallerThan900px ? 'font-size-m' : 'font-size-l'"
      border-radius="border-radius-12"
    />
    <AppFlicker
      width="spacing-96"
      height="spacing-24"
      border-radius="border-radius-8"
    />
    <AppFlicker
      width="100%"
      height="spacing-64"
      border-radius="border-radius-12"
      :margin="{ ySpacing: 'spacing-12' }"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-details-main-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-4);
}
</style>
